import { isPromise } from 'radash';

export interface LogMethod {
  (...message: unknown[]): void;
}

export interface TimeOptions {
  logTimeGreaterThan?: number;
  logStart?: boolean;
}

export function time<R>(log: LogMethod, label: string, action: () => R, options?: TimeOptions): R;
export function time(log: LogMethod, label: string, options?: TimeOptions): { dispose(): void } & Disposable;
export function time<R>(
  log: LogMethod,
  label: string,
  actionOrOptions?: (() => R) | TimeOptions,
  options?: TimeOptions,
): R | ({ dispose(): void } & Disposable) {
  const action = typeof actionOrOptions === 'function' ? actionOrOptions : undefined;
  options ??= typeof actionOrOptions === 'object' ? actionOrOptions : {};

  const { logTimeGreaterThan, logStart = logTimeGreaterThan === undefined } = options;

  const start = performance.now();

  if (logStart) {
    log(`${label}...`);
  }

  const dispose = () => {
    const end = performance.now();
    const duration = end - start;

    if (logTimeGreaterThan !== undefined && duration <= logTimeGreaterThan) {
      return;
    }

    let stringDuration;
    if (duration < 1000) {
      stringDuration = `${duration.toFixed(2)} ms`;
    } else {
      stringDuration = `${(duration / 1000).toFixed(2)} s`;
    }
    log(`${label} - done in ${stringDuration}`);
  };

  if (action) {
    const result = action();
    if (isPromise(result)) {
      result.then(dispose).catch(() => {});
      return result;
    } else {
      dispose();
      return result;
    }
  } else {
    return {
      dispose,
      [Symbol.dispose]: dispose,
    };
  }
}
